import React from 'react';

import * as style from './footer.module.less';
import '../../../styles/global.less';

const Footer = () => {
  return (
    <div className={style.footer}>
      <footer>©2021 zoniha.</footer>
    </div>
  );
};

export default Footer;
